import {
	ICalculateInstallemntRequest,
	ICalculateInstallemntResponse,
} from 'utils/api/models/vouchers/calculateInstallment';
import GenericService from 'services/genericService';
import { getSmartVoucher, calculateInstallment } from 'utils/api/queries/microApi';
import { Observable } from 'rxjs';
import { ISmartVouchersResponse } from 'utils/api/models/vouchers/getSmartVoucher';

export class VouchersService extends GenericService {
	public static getSmartVoucher(cr: string, phone: string): Observable<ISmartVouchersResponse> {
		return getSmartVoucher(cr, phone).call();
	}

	public static calculateInstallment(
		request: ICalculateInstallemntRequest
	): Observable<ICalculateInstallemntResponse> {
		return calculateInstallment(request).call();
	}
}
